import React from "react";

import Button from '../../../Form/Button/Button';
import {LoadingButton} from '../../../Form/Button/Button';
import {formatCurrency} from '../../../../utils/helpers';
import withFeatureFlags from '../../../FeatureFlags/withFeatureFlags';

/** @import {SummaryStepProps} from "./SummaryStepTypes" */
/** @import {WithFeatureFlagsProps} from "../../../FeatureFlags/FeatureFlagsTypes" */

import './withdrawal.scss';

function SummaryStep(/** @type {SummaryStepProps & WithFeatureFlagsProps} */ props) {
    const {
        onCancel,
        onConfirm,
        amount,
        productName,
        stepUpAmount,
        isNoticeWithdrawal,
        selectedAccount,
        loading
    } = props;

    const shouldStepUp = () => amount && stepUpAmount && amount >= stepUpAmount;

    const onSubmitClicked = async (/** @type {React.MouseEvent<HTMLAnchorElement, MouseEvent>} */ event) =>  {
        event.preventDefault();
        if (typeof onConfirm === 'function') await onConfirm(event);
        return false;
    };

    const onCancelClicked = (/** @type {React.MouseEvent<HTMLAnchorElement, MouseEvent>} */ event) =>  {
        event.preventDefault();
        if (typeof onCancel === 'function') onCancel(event);
        return false;
    };

    const renderConfirmButton = () => {
        return loading ?
            <LoadingButton size='med' /> :
            <Button size='med' type="submit" label={shouldStepUp() || isNoticeWithdrawal ? "Confirm" : "Send"}
                    onClick={onSubmitClicked} disabled={loading}/>
    };

    return (
        <form className="withdrawal withdrawal--step-1">
            <div className="withdrawal__section">
                <h3 className="withdrawal__title">Summary</h3>
                <div className="withdrawal__product">
                    <span className="withdrawal__product-key">Scheduled withdrawal of {amount ? formatCurrency(amount) : ""}</span>
                </div>
            </div>
            <div className="withdrawal__divider"/>
            <div className="withdrawal__section-bigger">
                <div className="withdrawal__line"><strong>From</strong> {productName}</div>
                <div className="withdrawal__line"><strong>To</strong> {selectedAccount?.label}</div>
            </div>
            <div className="withdrawal__divider"/>
            <div className="withdrawal__section">
                <div className="withdrawal__section--horizontal">
                    <div className="withdrawal__section">
                        <div className="withdrawal__line"><strong>Before you confirm:</strong></div>
                        <div className="withdrawal__line">Don't forget you wont be able to access this money again until
                            your term ends.
                        </div>
                    </div>
                    <div className="withdrawal__actions">
                        {renderConfirmButton()}
                        <Button variant='secondary' size='med' type="button" label="Cancel"
                                onClick={onCancelClicked} disabled={loading}/>
                    </div>
                </div>
            </div>
        </form>
    );
}

export default withFeatureFlags(SummaryStep);